// 引入element英文语言
import eleEn from 'element-ui/lib/locale/lang/en'
import iviewEn from 'view-design/dist/locale/en-US'
import index from '@/views/index/locales/en' // 结算报表模块
import settlement from '@/views/settlement/locales/en' // 结算报表模块
// import dataReport from '@/views/dataReport/locales/en' // 交易分析模块
import tradeEchart from '@/views/transactionAnalysis/locales/en' // 交易分析模块
import paymentRecord from '@/views/paymentRecord/locales/en' // 自动提现模块
import fundManagement from '@/views/fundManagement/locales/en' // 提现模块
import components from '@/components/locales/en' // compontnts文件夹中的公共组件
import webList from '@/views/websiteCenter/locales/en' // 网站管理
import login from '@/views/login/locales/en' // 登录注册
import home from '@/views/exhibition/locales/en' // 登录注册
import account from '@/views/accountCenter/locales/en' // 账号中心
import chargeBack from '@/views/riskManagement/chargeback/locales/en' // 拒单
import certification from '@/views/certification/locales/en' // 实名认证
import cashAccount from '@/views/cashAccount/locales/en' // 提现账户
import logistics from '@/views/logisticsManage/locales/en' // 物流管理
import riskTranscation from '@/views/riskManagement/riskTransactionManagement/locales/en' // 风险订单
import system from '@/views/system/locales/en' // 权限管理
import withdrawModule from '@/views/withdrawModule/locales/en' // 提现模块
import homePage from '@/views/homePage/locales/en' // 首页
import messageReceiverSetting from '@/views/messageReceiverSetting/locales/en' // 首页
import blackList from '@/views/riskManagement/blackList/locales/en' // 黑名单
import whiteList from '@/views/riskManagement/whiteList/locales/en' // 白名单
import selectWebsite from '@/views/ppAuthorization/locales/en'
import tradeType from '@/views/trade-type/locales/en'
import paymentLink from '@/views/paymentLink/locales/en'
import checkoutCustomSettings from '@/views/checkoutCustomSettings/locales/en'
import messageCenter from '@/views/messageCenter/locales/en' // 消息中心
import disputeManage from '@/views/riskManagement/disputeManage/locales/en' // 争议订单管理
import offlineKyc from '@/views/offlineKyc/locales/en' // 线下KYC
import storeManage from '@/views/storeManage/locales/en'
import landing from '@/views/landing/locales/en' // 官网

const en = {
	...eleEn,
	...iviewEn,
	index,
	settlement,
	// dataReport,
	tradeEchart,
	paymentRecord,
	certification,
	fundManagement,
	components,
	chargeBack,
	webList,
	account,
	login,
	home,
	logistics,
	withdrawModule,
	cashAccount,
	riskTranscation,
	homePage,
	system,
	messageReceiverSetting,
	blackList,
	whiteList,
	selectWebsite,
	tradeType,
	paymentLink,
	checkoutCustomSettings,
	messageCenter,
	disputeManage,
	offlineKyc,
	storeManage,
	landing
}

export default en
